import { useSearchParams } from 'react-router-dom';

export type PeekType = 'reconstructed' | 'document' | 'page';
const PEEK_TYPES: PeekType[] = ['reconstructed', 'document', 'page'];

export function peekContentKey({ type, id }: { type: PeekType; id: string }): string {
  return `${type}:${id}`;
}

export function peekRoute(type: PeekType, id: string): string {
  const base = { reconstructed: '/reconstructed-documents', document: '/documents', page: '/document-pages' }[type];
  return `${base}/${id}`;
}

export function usePeek() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('peek');
  const peek = parsePeek(raw);

  const openPeek = (type: PeekType, id: string) =>
    setSearchParams((prev) => {
      const p = new URLSearchParams(prev);
      p.set('peek', `${type}:${id}`);
      return p;
    }); // push (default) so the back button closes the peek

  const closePeek = () =>
    setSearchParams(
      (prev) => {
        const p = new URLSearchParams(prev);
        p.delete('peek');
        return p;
      },
      { replace: true }, // replace so back doesn't reopen the peek
    );

  return { peek, openPeek, closePeek };
}

function parsePeek(raw: string | null): { type: PeekType; id: string } | null {
  if (!raw) return null;
  const idx = raw.indexOf(':');
  if (idx < 1) return null;
  const type = raw.slice(0, idx);
  const id = raw.slice(idx + 1);
  if (!id || !PEEK_TYPES.includes(type as PeekType)) return null;
  return { type: type as PeekType, id };
}
